import { defineStore } from 'pinia'
import * as _gFunc from '@/helpers/funcHelper'

export const useAccessControlStore = defineStore({
  id: 'access-control-store',
  state: () => {
		return {//THEME DEFAULT
			activeUser: {},
			userList: [],
			roleList: [],
		}
  },
  getters: {
  },
  actions: {
		setActiveUser(value){
			this.activeUser = value;
			_gFunc.setLocalStorage('active_user', value);
			_gFunc.setLocalStorage('acces_codes', value.access_codes);
		},
		setActiveToken(value){
			if(!_gFunc.isEmpty(value.access_token)){
				localStorage.setItem('token', value.access_token);
			}
			if(!_gFunc.isEmpty(value.app_code)){
				localStorage.setItem('app_code', value.app_code);
			}
			let exIn = !_gFunc.isEmpty(value.expires_in) ? value.expires_in : 2629743;
			let exp = Math.round(new Date().getTime() / 1000) + exIn;
			localStorage.setItem('exp', exp);
		},
		setRoleList(value) {
			this.roleList = value
		},
		setUserList(value) {
			this.userList = value
		}
  }
})